import "./Wishlist.scss";
import "./WishlistMobile.scss";
import React, { useState, useEffect } from "react";
import dialog from "../../../../Assets/Design/Dialog.png";
import MainContentModal from "../../../../PageProducts/ProductContent/PPCMainContent/MainContentModal/MainContentModal";
import ViewProductModal from "../../../../PageProducts/ProductContent/PPCMainContent/MainContentModal/ViewProductModal/ViewProductModal";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaTimes } from "react-icons/fa";
import sale from "../../../../Assets/Design/Sale.png";
import { useMediaQuery } from "react-responsive";

export default function Wishlist() {
  const [wishlist, setWishlist] = useState([]);
  const [likedMap, setLikedMap] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [productId, setProductId] = useState(null);
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 600 });

  // ✅ Fetch wishlist items
  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`,
          {
            credentials: "include",
          }
        );
        const data = await res.json();

        if (!data?.CP_ID) return;

        const wishRes = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/wishlist/get-wishlist-by-id/${data.CP_ID}`
        );
        const wishData = await wishRes.json();

        //console.log("wishData:", wishData);

        if (wishRes.ok && Array.isArray(wishData)) {
          setWishlist(wishData);
          const map = {};
          wishData.forEach((p) => (map[p.PD_ID] = true));
          setLikedMap(map);
        }
      } catch (err) {
        console.error("Failed to fetch wishlist:", err);
      }
    };
    fetchWishlist();
  }, []);

  // ✅ Toggle wishlist add/remove
  const toggleLike = async (productId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`,
        {
          credentials: "include",
        }
      );
      const data = await res.json();

      if (!data?.CP_ID) {
        const confirmLogin = window.confirm(
          "You need to log in to manage your wishlist. Log in now?"
        );
        if (confirmLogin) navigate("/login");
        return;
      }

      const customerId = data.CP_ID;
      const isLiked = likedMap[productId];
      const command = isLiked ? "remove" : "add";

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/wishlist/add-drop-wish/${productId}/${customerId}/${command}`,
        {
          method: "POST",
          credentials: "include",
        }
      );

      if (response.ok) {
        setLikedMap((prev) => ({ ...prev, [productId]: !isLiked }));
        if (isLiked) {
          // Remove from UI
          setWishlist((prev) => prev.filter((p) => p.PD_ID !== productId));
        }
      } else {
        console.error("Wishlist toggle failed");
      }
    } catch (error) {
      console.error("Error toggling wishlist:", error);
    }
  };

  return (
    <>
      <div className="wishlist-container">
        <div className="wishlist-header">
          <div className="wishlist-header-wrapper">MY WISHLIST</div>
        </div>

        <div className="wish-container scrollable-div">
          {wishlist.length ? (
            wishlist.map((product) => (
              <div className="wishlist-card-wrapper" key={product.PD_ID}>
                <div className="prod-picture-wrapper">
                  {/* ❌ Remove from Wishlist Button */}
                  <button
                    className="remove-wish-btn"
                    title="Remove from wishlist"
                    onClick={() => toggleLike(product.PD_ID)}
                  >
                    <FaTimes />
                  </button>

                  {/* SALE Badge */}
                  {product.PD_SalePrice !== 0 && (
                    <img className="prod-sale-badge" src={sale} />
                  )}

                  {/* Product Image */}
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${product.PD_ID}/${product.PD_ProductPicPath?.[0]}`}
                    alt={product.PD_Name}
                    onClick={() => {
                      if (!isMobile) {
                        setProductId(product.PD_ID);
                        setModalOpen(true);
                      }
                    }}
                  />
                </div>

                <div className="prod-card-details">
                  <span className="prod-name">{product.PD_Name}</span>
                </div>
                <button
                  className="view-product-btn"
                  onClick={() => {
                    navigate(`/products/${product.PD_ID}`, {
                      state: { isLiked: likedMap[product.PD_ID] },
                    });
                  }}
                >
                  View Product
                </button>
              </div>
            ))
          ) : (
            <div className="no-products">Your wishlist is empty.</div>
          )}
          <div className="add-more-wrapper">
            {" "}
            <button className="add-more" onClick={() => navigate(`/products`)}>
              <FaPlus />
              ADD
              <br /> MORE
            </button>
          </div>
        </div>
      </div>

      {/* ✅ Product Modal */}
      <MainContentModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
      >
        <ViewProductModal productId={productId} onToggleLike={toggleLike} />
      </MainContentModal>
    </>
  );
}
